<template>



    <div class="nk-app-root">
            <div class="nk-main ">
                <div class="nk-wrap nk-wrap-nosidebar">
                    <div class="nk-content ">
                        <div class="nk-split nk-split-page nk-split-md">
                            <div class="nk-split-content nk-block-area nk-block-area-column nk-auth-container bg-white">
                                <div class="nk-block nk-block-middle nk-auth-body">
                                    <div class="brand-logo pb-5"><a href="#" class="logo-link">
                                        <img class="logo-light logo-img logo-img-lg" :src="gorsel.logoIcon">
                                        <img class="logo-dark logo-img logo-img-lg"  :src="gorsel.logoIcon" alt="logo-dark"></a></div>
                                    <div class="nk-block-head">
                                        <div class="nk-block-head-content">
                                            <h5 class="nk-block-title">Tfon Makine Fuar Görüşme Takip Uygulaması</h5>
                                            <div class="nk-block-des">
                                                <p>Lütfen Kullanıcı Bilgilerini Giriniz</p>
                                            </div>
                                        </div>
                                    </div>
                                    <form action="#" @submit.prevent="login" >
                                        <div class="form-group">
                                            <div class="form-label-group"><label class="form-label" for="default-01">Kullanıcı Adı</label><a class="link link-primary link-sm" tabindex="-1"
                                                    href="#"></a></div>
                                            <div class="form-control-wrap"><input type="text" v-model="username" required
                                                    class="form-control form-control-lg" id="default-01"
                                                    placeholder="Kullanıcı Girişi"></div>
                                        </div>
                                        <div class="form-group">
                                            <div class="form-label-group"><label class="form-label"
                                                    for="password" >Şifre</label><a class="link link-primary link-sm"
                                                    tabindex="-1" href="#">Şifre Unuttum</a></div>
                                            <div class="form-control-wrap"><a  href="#"
                                                    class="form-icon form-icon-right passcode-switch lg"
                                                    data-target="password"><em
                                                        class="passcode-icon icon-show icon ni ni-eye"></em><em
                                                        class="passcode-icon icon-hide icon ni ni-eye-off"></em></a><input
                                                    type="password" class="form-control form-control-lg" id="password" placeholder="Şifreniz" v-model="password" required></div>
                                        </div>
                                        <div class="form-group"><button class="btn btn-lg btn-primary btn-block" type="submit">Giriş Yap</button></div>
                                    </form>
                                
                             
                                   
                                </div>
                                <div class="nk-block nk-auth-footer">
                                    <div class="nk-block-between">
                                        <ul class="nav nav-sm">
                                            <li class="nav-item"><a class="link link-primary fw-normal py-2 px-3"
                                                    href="#">Destek Gifadwork</a></li>
                                           
                                          
                                        </ul>
                                    </div>
                                    <div class="mt-3">
                                        <p>&copy; 2024 Tfon Makine</p>
                                    </div>
                                </div>
                            </div>
                            <div class="nk-split-content nk-split-stretch bg-abstract"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    
    
    
        <div class="pmo-lv pmo-dark"><a class="pmo-close" href="#"><em class="ni ni-cross"></em></a><a class="pmo-wrap"
                target="_blank" href="#">
                <div class="pmo-text text-white">Looking for functional script for Investment Platform? Check out <em
                        class="ni ni-arrow-long-right"></em></div>
            </a></div>
            <a class="pmo-st pmo-dark" target="_blank" href="#">
            <div class="pmo-st-img"><img :src="gorsel.logoIcon" alt="Investorm"></div>
            <div class="pmo-st-text">Looking for Advanced <br> Investment Platform?</div>
        </a>
    
    
    
    
    
    
      
    
      </template>
      
      <script>
    import axios from 'axios'
    import axiosCustom from "@/services/axiosCustom";
    import { useLocalStorage } from '@vueuse/core';
    import logoIcon from '@/assets/images/logo-2.png';
    
      export default {
        data() {
          return {
            username: '',
            password: '',
        
            gorsel: {
                'logoIcon': logoIcon, 
          
            },
          };
        },
        mounted() {
        this.updateBodyClass();
        },
        methods: {
            async login() {
            const token = useLocalStorage('token', null);
            const formData = new FormData();
            formData.append('kullaniciadi', this.username);
            formData.append('kullanicisifre', this.password);
      
            try {
              const response = await axios.post(this.$globalVariable.apiUrl + "app/login", formData);
              token.value = response.data.token; // Token'ı useLocalStorage ile saklama
              axiosCustom.defaults.headers['Authorization'] = `Bearer ${token.value}`; // Axios başlıklarını güncelleyin
             

              this.$router.push('/anasayfa');

              this.hata = false;
            } catch (error) {
              this.username = '';
              this.password = '';
              this.hata = true;
              console.error('Login error:', error);
              this.$toast.error("Kullanıcı Girişi Yapılamadı");
            }
          },
    
          updateBodyClass() {
                const currentPath = this.$route.path;
                const bodyElement = document.body;
    
                if (currentPath === '/login') {
                bodyElement.className = 'nk-body npc-default pg-auth no-touch nk-nio-theme';
                } else {
                bodyElement.className = 'nk-body npc-default has-apps-sidebar has-sidebar';
                }
            }
      
        },
      };
      </script>